import { Inject } from '@angular/core';
import templateSource from './app.component.html';
              import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz');
import { Component, OnInit, ChangeDetectorRef, enableProdMode } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/app.component.scss */
:host {
  display: block;
  min-height: 100%;
  background: var(--design-bg);
  color: var(--design-body-text);
}

:host ::ng-deep .design-card,
:host ::ng-deep .design-card-tinted {
  border: 1px solid var(--design-border);
  border-radius: var(--design-radius-card);
  box-shadow: var(--design-shadow);
}

:host ::ng-deep .design-card {
  background: var(--design-card-bg);
}

:host ::ng-deep .design-card-tinted {
  background: var(--design-card-tinted);
}

:host ::ng-deep .design-button-primary,
:host ::ng-deep .design-button-secondary {
  min-height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border-radius: var(--design-radius-button);
  padding: 0 13px;
  font-size: 13px;
  font-weight: 850;
  text-decoration: none;
}

:host ::ng-deep .design-button-primary {
  border: 1px solid var(--color-cta-primary-bg);
  background: var(--color-cta-primary-bg);
  color: var(--color-cta-primary-text);
}

:host ::ng-deep .design-button-secondary {
  border: 1px solid var(--color-cta-secondary-border);
  background: var(--color-cta-secondary-bg);
  color: var(--color-cta-secondary-text);
}

:host ::ng-deep .design-button-primary:hover,
:host ::ng-deep .design-button-primary:focus-visible {
  border-color: var(--color-cta-primary-hover);
  background: var(--color-cta-primary-hover);
  color: var(--color-cta-primary-text);
  box-shadow: var(--design-focus-ring);
}

:host ::ng-deep .design-button-secondary:hover,
:host ::ng-deep .design-button-secondary:focus-visible {
  border-color: var(--color-border-emphasis);
  background: var(--color-cta-secondary-hover-bg);
  color: var(--color-cta-secondary-text);
  box-shadow: var(--design-focus-ring);
}

:host ::ng-deep .design-chip,
:host ::ng-deep .design-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border: 1px solid var(--color-chip-border);
  border-radius: 999px;
  background: var(--color-chip-bg);
  color: var(--color-chip-text);
  font-size: 12px;
  font-weight: 750;
  line-height: 1;
}

:host ::ng-deep .design-chip {
  min-height: 30px;
  padding: 0 10px;
}

:host ::ng-deep .design-badge {
  min-height: 24px;
  padding: 0 8px;
}

:host ::ng-deep .design-section-title,
:host ::ng-deep .design-card-title {
  color: var(--design-text);
  letter-spacing: 0;
  word-break: keep-all;
  overflow-wrap: break-word;
}

:host ::ng-deep .design-section-title {
  margin: 0;
  font-size: var(--design-title-size);
  line-height: var(--design-title-line);
  font-weight: 850;
}

:host ::ng-deep .design-section-description {
  margin: 0;
  color: var(--design-text-secondary);
  font-size: var(--design-description-size);
  line-height: 1.62;
}

:host ::ng-deep .design-card-title {
  margin: 0;
  font-size: var(--design-card-title-size);
  line-height: 1.35;
  font-weight: 800;
}

/* Review 157 common UI */
:host {
  --color-page-background: #FFFFFF;
  --color-card-background: #FFFFFF;
  --color-surface-muted: #F5F5F5;
  --color-surface-muted-strong: #F5F5F5;
  --color-surface-selected: #F5F5F5;
  --color-text-heading: #222222;
  --color-text-body: #333333;
  --color-text-secondary: #666666;
  --color-text-placeholder: #8A8A8A;
  --color-border-default: #E5E5E5;
  --color-border-emphasis: #BDBDBD;
  --color-cta-primary-bg: #2B2B2B;
  --color-cta-primary-hover: #171717;
  --color-cta-primary-text: #FFFFFF;
  --color-cta-secondary-bg: #FFFFFF;
  --color-cta-secondary-text: #2B2B2B;
  --color-cta-secondary-border: #BDBDBD;
  --color-cta-secondary-hover-bg: #F5F5F5;
  --color-chip-bg: #F5F5F5;
  --color-chip-text: #2B2B2B;
  --color-chip-border: #E5E5E5;
  --design-bg: #FFFFFF;
  --design-card-bg: #FFFFFF;
  --design-bg-muted: #F5F5F5;
  --design-card-tinted: #F5F5F5;
  --design-card-tinted-strong: #F5F5F5;
  --design-surface-muted: #F5F5F5;
  --design-selected-bg: #F5F5F5;
  --design-accent: #2B2B2B;
  --design-accent-strong: #171717;
  --design-text: #222222;
  --design-body-text: #333333;
  --design-text-secondary: #666666;
  --design-text-muted: #8A8A8A;
  --design-border: #E5E5E5;
  --design-border-soft: #E5E5E5;
  --design-border-strong: #BDBDBD;
  --design-shadow: 0 1px 2px rgba(30, 30, 30, 0.06);
  --design-shadow-strong: 0 2px 6px rgba(30, 30, 30, 0.08);
  --design-focus-ring: 0 0 0 3px rgba(43, 43, 43, 0.2);
  --design-radius-card: 8px;
  --design-radius-button: 8px;
  min-height: 100vh;
  background: #FFFFFF;
  color: #333333;
  font-family: SUIT, "Noto Sans KR", system-ui, sans-serif;
  font-size: 16px;
  line-height: 1.6;
}

:host ::ng-deep :where(a, button, input, select, textarea, summary, [tabindex]):focus-visible {
  outline: 3px solid rgba(43, 43, 43, 0.28);
  outline-offset: 2px;
}

:host ::ng-deep :where(button, input, select, textarea):disabled,
:host ::ng-deep [aria-disabled=true] {
  cursor: not-allowed;
  opacity: 0.5;
}`],
})
export class AppComponent implements OnInit {
    constructor(@Inject( Service)         public service: Service,@Inject( Router)         public router: Router,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( TranslateService    )         public translate: TranslateService    ) {
        window['MonacoEnvironment'] = {
            getWorkerUrl: function (moduleId: string, label: string) {
                return `/lib/vs/base/worker/workerMain.js`;
            }
        };
    }

    public async ngOnInit() {
        enableProdMode();
        document.documentElement.style.backgroundColor = "#FFFFFF";
        document.body.style.backgroundColor = "#FFFFFF";
        await this.service.init(this);
    }
}